/**
 * Organizaciones que ya tienen su página web construida con Veekls (o son parte
 * de las vitrinas de ejemplo del pop-up) y por lo tanto nunca deben ver el
 * aviso "Quiero mi página con Veekls". IDs, no nombres: los nombres cambian
 * (mayúsculas, tildes, razón social) y un match de texto puede fallar en
 * silencio. Resuelto a mano contra la colección `organizations` el 2026-08-20.
 */
export const WEBSITE_PROMO_EXCLUDED_ORG_IDS: ReadonlySet<string> = new Set([
  '67e590564537f1046999aa9c', // Tecfin
  '67ed8b61416606046ec5216a', // Auto Top
  '6731dced416606046ec51fa0', // Automotriz Santa María
  '688a271a416606046ec52289', // Automotora El Maitén
  '66fb3475416606046ec51ec3', // The Super Garage
  '66e2fb512b168a0ea2cbf991', // UCARS
  '692ef56a416606046ec52365', // Automotriz Olea Flaño
  '689260a6416606046ec522b2', // PH MOTORS
  '675076b5416606046ec52036', // Garrido Autos
  '5ce5ce3239939e0479e0c8f7', // Vial Besa
  '67196e6b4537f1046999a85a', // Vial Besa Automoviles
  '5ca37791faef550d1b28678f', // Automec
])
